import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { selectContentTotalLength } from '../../../spacesPlatform/selectors/ContentSelectors';
import { AllLabelsSpace, AllLabelsSpaceDispatchProps, AllLabelsSpaceOwnProps, AllLabelsSpaceStateProps } from './AllLabelsSpace';

const mapStateToProps: MapStateToProps<AllLabelsSpaceStateProps> = (state: AppState) => ({
  numberOfFetchedLabels: selectContentTotalLength(state),
  isBusyFetchingItems: state.contentExplorer.content.isBusy,
});

const mapDispatchToProps: MapDispatchToProps<AllLabelsSpaceDispatchProps> = (dispatch) => bindActionCreators({
  requestSpaceContents,
}, dispatch);

export const ConnectedAllLabelsSpace: React.ComponentClass<AllLabelsSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(AllLabelsSpace);
